/**
 * Vendored from react-text-annotate v0.3.0 (https://github.com/mcamac/react-text-annotate)
 * MIT License — Copyright (c) 2018 Martin Camacho. See utils.js for why.
 *
 * API is unchanged: <TokenAnnotator tokens value onChange getSpan renderMark />
 * plus any extra props spread onto the wrapping div.
 */
import React from 'react';
import Mark from './Mark';
import { selectionIsEmpty, selectionIsBackwards, splitTokensWithOffsets } from './utils';

const Token = (props) => <span data-i={props.i}>{props.content} </span>;

const TokenAnnotator = (props) => {
  const renderMark = props.renderMark || ((markProps) => <Mark {...markProps} />);

  const getSpan = (span) => {
    if (props.getSpan) return props.getSpan(span);
    return { start: span.start, end: span.end };
  };

  const handleMouseUp = () => {
    if (!props.onChange) return;

    const selection = window.getSelection();

    if (selectionIsEmpty(selection)) return;

    if (
      !selection.anchorNode.parentElement.hasAttribute('data-i') ||
      !selection.focusNode.parentElement.hasAttribute('data-i')
    ) {
      window.getSelection().empty();
      return false;
    }

    let start = parseInt(selection.anchorNode.parentElement.getAttribute('data-i'), 10);
    let end = parseInt(selection.focusNode.parentElement.getAttribute('data-i'), 10);

    if (selectionIsBackwards(selection)) {
      [start, end] = [end, start];
    }

    end += 1;

    props.onChange([
      ...props.value,
      getSpan({ start, end, tokens: props.tokens.slice(start, end) })
    ]);
    window.getSelection().empty();
  };

  const handleSplitClick = ({ start, end }) => {
    // Find and remove the matching split.
    const splitIndex = props.value.findIndex((s) => s.start === start && s.end === end);

    if (splitIndex >= 0) {
      props.onChange([...props.value.slice(0, splitIndex), ...props.value.slice(splitIndex + 1)]);
    }
  };

  const { tokens, value, onChange, getSpan: _, renderMark: __, ...divProps } = props;

  const splits = splitTokensWithOffsets(tokens, value);

  return (
    <div {...divProps} onMouseUp={handleMouseUp}>
      {splits.map((split) =>
        split.mark ? (
          renderMark({
            key: `${split.start}-${split.end}`,
            ...split,
            onClick: handleSplitClick
          })
        ) : (
          <Token key={split.i} {...split} />
        )
      )}
    </div>
  );
};

export default TokenAnnotator;
